import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../providers/AuthContext';
import Loader from '../Loader';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Profile = () => {
  const { user, token, loading, logout } = useContext(AuthContext);
  const [serverData, setServerData]      = useState(null);
  const [err, setErr]                    = useState('');
  const [orders, setOrders]              = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/user/profile`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (!res.ok) throw new Error((await res.json()).message);
        setServerData(await res.json());
      } catch (e) {
        setErr(e.message);
      }
    })();
    
    // Cargar historial de pedidos
    (async () => {
      try {
        setLoadingOrders(true);
        const resOrders = await fetch(`${process.env.REACT_APP_API_URL}/orders/my-orders`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        });
        if (!resOrders.ok) throw new Error('Error al cargar pedidos');
        setOrders(await resOrders.json());
      } catch (e) {
        console.error('Error cargando órdenes:', e);
      } finally {
        setLoadingOrders(false);
      }
    })();
  }, [token]);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'pendiente_pago': return <span className="badge bg-warning text-dark">Pendiente Pago</span>;
      case 'en espera': return <span className="badge bg-info text-dark">En Espera</span>;
      case 'en preparacion': return <span className="badge bg-primary">En Preparación</span>;
      case 'enviado': return <span className="badge bg-info">Enviado</span>;
      case 'entregado': return <span className="badge bg-success">Entregado</span>;
      case 'cancelado': return <span className="badge bg-danger">Cancelado</span>;
      default: return <span className="badge bg-secondary">{status}</span>;
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (!user) {
    navigate('/user');
    return null;
  }

  return (
    <div className="container-fluid py-4 py-md-5" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        {/* Header Card - Avatar y Info Principal */}
        <div 
          className="card shadow-sm mb-4" 
          style={{ 
            border: 'none',
            borderRadius: '16px',
            overflow: 'hidden'
          }}
        >
          <div 
            className="card-body text-center py-5"
            style={{
              background: 'linear-gradient(135deg, #000000 0%, #2d2d2d 100%)'
            }}
          >
            <div className="position-relative d-inline-block mb-3">
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt="Avatar"
                  className="rounded-circle"
                  style={{ 
                    width: '120px', 
                    height: '120px', 
                    objectFit: 'cover',
                    border: '4px solid #1f8e38',
                    boxShadow: '0 4px 12px rgba(31, 142, 56, 0.3)'
                  }}
                  onError={e => { 
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className="rounded-circle"
                style={{
                  width: '120px',
                  height: '120px',
                  backgroundColor: '#1f8e38',
                  color: 'white',
                  display: user.photoURL ? 'none' : 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '48px',
                  fontWeight: 'bold',
                  border: '4px solid #1f8e38',
                  boxShadow: '0 4px 12px rgba(31, 142, 56, 0.3)'
                }}
              >
                {user.displayName?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              {user.emailVerified && (
                <div 
                  className="position-absolute"
                  style={{
                    bottom: '0',
                    right: '0',
                    backgroundColor: '#1f8e38',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '3px solid #1a1a1a',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                  title="Cuenta verificada"
                >
                  <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                  </svg>
                </div>
              )}
            </div>
            <h2 className="mb-2 text-white" style={{ fontWeight: '600' }}>
              {user.displayName}
            </h2>
            <p className="mb-0" style={{ color: '#1f8e38', fontSize: '1rem' }}>
              {user.email}
            </p>
          </div>
        </div>

        {/* Información de Usuario */}
        <div 
          className="card shadow-sm mb-4" 
          style={{ 
            border: 'none',
            borderRadius: '16px'
          }}
        >
          <div className="card-body p-4">
            <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
              Información de la Cuenta
            </h5>
            <div className="row g-4">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#1f8e38',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      UID
                    </h6>
                  </div>
                  <p className="mb-0 text-break" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.uid}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: user.emailVerified ? '#1f8e38' : '#6c757d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Verificado
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.emailVerified ? 'Sí' : 'No'}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#1f8e38',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Teléfono
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.phoneNumber || '–'}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#1f8e38',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Miembro desde
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {new Date(user.metadata.creationTime).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ai-products-profile-card card shadow-sm mb-4">
          <div className="card-body p-4 d-flex flex-column flex-sm-row align-items-sm-center gap-3">
            <div className="ai-products-profile-icon" aria-hidden="true">
              <i className="fa-solid fa-robot"></i>
            </div>
            <div className="flex-grow-1">
              <h5 className="mb-1">Mis Productos IA</h5>
              <p className="mb-0">
                Consultá los diseños que creaste con inteligencia artificial y agregalos al carrito cuando quieras.
              </p>
            </div>
            <Link
              to={`/productoai/${encodeURIComponent(user.email)}`}
              className="btn ai-products-profile-action"
            >
              Ver mis productos
              <i className="fa-solid fa-arrow-right ms-2" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        {/* Historial de Pedidos */}
        <div className="card shadow-sm mb-4" style={{ border: 'none', borderRadius: '16px' }}>
          <div className="card-body p-4">
            <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
              <i className="fa-solid fa-box me-2"></i> Mis Pedidos
            </h5>
            
            {loadingOrders ? (
              <div className="text-center py-4">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
              </div>
            ) : orders.length === 0 ? (
              <div className="text-center py-5 bg-light rounded">
                <i className="fa-solid fa-bag-shopping mb-3" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                <h6 className="text-muted mb-0">Aún no tienes pedidos registrados</h6>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Orden #</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                      <th>Total</th>
                      <th>Detalles</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map(order => (
                      <tr key={order._id}>
                        <td><strong>#{order.orderNumber}</strong></td>
                        <td>{new Date(order.date).toLocaleDateString()}</td>
                        <td>{getStatusBadge(order.status)}</td>
                        <td>${order.total}</td>
                        <td>
                          <button 
                            className="btn btn-sm btn-outline-dark"
                            onClick={() => {
                              const itemsHtml = order.items.map(i => `
                                <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #eee; padding: 8px 0;">
                                  <div style="text-align: left;">
                                    <span style="font-weight: bold;">${i.quantity}x</span> ${i.name}
                                  </div>
                                  <div style="font-weight: bold; color: #1f8e38;">$${i.price * i.quantity}</div>
                                </div>
                              `).join('');

                              Swal.fire({
                                title: `Orden #${order.orderNumber}`,
                                html: `
                                  <div style="text-align: left; margin-bottom: 15px;">
                                    <p style="margin: 0;"><strong>Fecha:</strong> ${new Date(order.date).toLocaleDateString()}</p>
                                    <p style="margin: 0;"><strong>Monto Total:</strong> $${order.total}</p>
                                  </div>
                                  <div style="background: #f8f9fa; border-radius: 8px; padding: 15px; max-height: 250px; overflow-y: auto;">
                                    <h6 style="text-align: left; margin-bottom: 10px; font-weight: bold;">Productos:</h6>
                                    ${itemsHtml}
                                  </div>
                                `,
                                icon: 'info',
                                confirmButtonColor: '#1a1a1a',
                                confirmButtonText: 'Cerrar'
                              });
                            }}
                          >
                            <i className="fa-solid fa-eye"></i> Ver
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Datos del Servidor */}
        {serverData && (
          <div 
            className="card shadow-sm mb-4" 
            style={{ 
              border: 'none',
              borderRadius: '16px'
            }}
          >
            <div className="card-body p-4">
              <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
                Datos desde Servidor
              </h5>
              <div className="row g-4">
                <div className="col-12 col-md-6">
                  <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <h6 className="mb-2" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      UID Servidor
                    </h6>
                    <p className="mb-0 text-break" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                      {serverData.uid}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <h6 className="mb-2" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Nombre Servidor
                    </h6>
                    <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                      {serverData.displayName}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Error Alert */}
        {err && (
          <div 
            className="alert alert-danger mb-4" 
            style={{ 
              borderRadius: '12px',
              border: 'none'
            }}
          >
            <strong>Error:</strong> {err}
          </div>
        )}

        {/* Botón Cerrar Sesión */}
        <div className="text-center">
          <button
            className="btn btn-lg px-5"
            onClick={() => logout()}
            style={{
              backgroundColor: '#1a1a1a',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#1f8e38';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(31, 142, 56, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#1a1a1a';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
